import LegalLayout from "./components/LegalLayout";

function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <section className="mb-10">
      <h2 className="text-xl font-bold text-faro-navy mb-4 pb-2 border-b border-faro-gray-mid">{title}</h2>
      <div className="text-faro-gray-text text-sm leading-relaxed space-y-3">{children}</div>
    </section>
  );
}

export default function PoliticaPrivacidadPage() {
  return (
    <LegalLayout title="Política de Privacidad" lastUpdated="26 de marzo de 2026">
      <Section title="1. Responsable del tratamiento">
        <ul className="list-disc list-inside space-y-1 pl-2">
          <li><strong className="text-faro-navy">Responsable:</strong> Faro Energía</li>
          <li><strong className="text-faro-navy">Domicilio:</strong> Castellón de la Plana, Comunitat Valenciana, España</li>
          <li><strong className="text-faro-navy">Correo electrónico:</strong> info@faroenergia.es</li>
          <li><strong className="text-faro-navy">Sitio web:</strong> faroenergia.es</li>
        </ul>
      </Section>

      <Section title="2. Finalidad del tratamiento de datos">
        <p>Faro Energía trata los datos personales facilitados por los usuarios con las siguientes finalidades:</p>
        <ul className="list-disc list-inside space-y-1 pl-2">
          <li>Gestionar y responder las solicitudes de información, contacto o estudio energético gratuito enviadas a través del formulario web.</li>
          <li>Prestar los servicios de consultoría energética contratados o solicitados.</li>
          <li>Enviar comunicaciones comerciales sobre nuestros servicios energéticos, siempre que el usuario haya prestado su consentimiento expreso.</li>
          <li>Cumplir con las obligaciones legales aplicables.</li>
        </ul>
      </Section>

      <Section title="3. Base legitimadora">
        <p>El tratamiento de los datos personales se basa en:</p>
        <ul className="list-disc list-inside space-y-1 pl-2">
          <li><strong className="text-faro-navy">Ejecución de un contrato o medidas precontractuales:</strong> cuando el usuario solicita información o contrata nuestros servicios.</li>
          <li><strong className="text-faro-navy">Consentimiento del interesado:</strong> para el envío de comunicaciones comerciales y el uso de cookies no esenciales.</li>
          <li><strong className="text-faro-navy">Obligación legal:</strong> cuando el tratamiento es necesario para cumplir con una norma aplicable.</li>
        </ul>
      </Section>

      <Section title="4. Conservación de datos">
        <p>
          Los datos personales se conservarán durante el tiempo necesario para cumplir con la finalidad para la que
          fueron recabados y, en su caso, para atender las posibles responsabilidades derivadas del tratamiento.
          Los datos facilitados para la gestión de consultas se conservarán durante el plazo de 3 años desde la
          última interacción, salvo que el usuario solicite su supresión antes.
        </p>
      </Section>

      <Section title="5. Destinatarios de los datos">
        <p>
          Faro Energía no cederá los datos personales a terceros, salvo obligación legal o en los supuestos en que
          sea necesario para prestar el servicio solicitado. Podrán acceder a los datos los proveedores de servicios
          tecnológicos (hosting, email marketing) que actúan como encargados del tratamiento bajo las garantías
          exigidas por el RGPD.
        </p>
      </Section>

      <Section title="6. Transferencias internacionales">
        <p>
          Faro Energía no realiza transferencias internacionales de datos fuera del Espacio Económico Europeo,
          salvo que los prestadores de servicios utilizados tengan sus servidores en terceros países con nivel
          adecuado de protección reconocido por la Comisión Europea.
        </p>
      </Section>

      <Section title="7. Derechos del interesado">
        <p>El usuario puede ejercer en cualquier momento los siguientes derechos:</p>
        <ul className="list-disc list-inside space-y-1 pl-2">
          <li><strong className="text-faro-navy">Acceso:</strong> conocer qué datos tratamos sobre usted.</li>
          <li><strong className="text-faro-navy">Rectificación:</strong> solicitar la corrección de datos inexactos.</li>
          <li><strong className="text-faro-navy">Supresión:</strong> solicitar la eliminación de sus datos cuando ya no sean necesarios.</li>
          <li><strong className="text-faro-navy">Limitación:</strong> solicitar la limitación del tratamiento en determinados supuestos.</li>
          <li><strong className="text-faro-navy">Portabilidad:</strong> recibir sus datos en formato estructurado.</li>
          <li><strong className="text-faro-navy">Oposición:</strong> oponerse al tratamiento de sus datos con fines comerciales.</li>
        </ul>
        <p>
          Para ejercer estos derechos, diríjase por escrito a <strong>info@faroenergia.es</strong>, indicando el
          derecho que desea ejercitar y adjuntando una copia de su DNI u otro documento identificativo.
        </p>
        <p>
          Si considera que el tratamiento de sus datos no es adecuado, puede presentar una reclamación ante la
          Agencia Española de Protección de Datos (AEPD) en <strong>www.aepd.es</strong>.
        </p>
      </Section>

      <Section title="8. Seguridad">
        <p>
          Faro Energía ha adoptado las medidas técnicas y organizativas necesarias para garantizar la seguridad
          de los datos personales y evitar su alteración, pérdida, tratamiento o acceso no autorizado, habida
          cuenta del estado de la tecnología, la naturaleza de los datos almacenados y los riesgos a los que
          están expuestos.
        </p>
      </Section>

      <Section title="9. Modificación de la política de privacidad">
        <p>
          Faro Energía se reserva el derecho de modificar esta Política de Privacidad para adaptarla a novedades
          legislativas, jurisprudenciales o de interpretación de la Agencia Española de Protección de Datos.
          Los cambios entrarán en vigor desde su publicación en el sitio web.
        </p>
      </Section>
    </LegalLayout>
  );
}
